import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import TransparencyList from '@/shared/product/details/ui/product-specifications/TransparencyList.vue';
import CertificateListItem from '@/shared/product/details/ui/product-specifications/CertificateListItem.vue';
import useProductSpecificationsTile
    from '@/shared/product/details/ui/product-specifications/useProductSpecificationsTile';
import { Certificate } from '@/types/productServerApi';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CertificatesList',
  props: {
    certificates: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
    certificates: Certificate[];
    title?: string;
}



const { transparencyReadMoreLinks } = useProductSpecificationsTile();
const anyCertificateHasImage = computed(() => props.certificates.some((certificate) => !!certificate.imageUrl));

const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TransparencyList, {
    title: __props.title,
    "read-more-label": _unref(labels).readMoreAboutCertificationsLabel,
    "read-more-link": _unref(transparencyReadMoreLinks).readMoreAboutCertificatesLink,
    tag: "div"
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", {
        class: _normalizeClass(["certificate-list-grid", {'reserve-space-for-image': _unref(anyCertificateHasImage)}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.certificates, (cert) => {
          return (_openBlock(), _createBlock(CertificateListItem, {
            key: cert.name,
            certificate: cert
          }, null, 8, ["certificate"]))
        }), 128))
      ], 2)
    ]),
    _: 1
  }, 8, ["title", "read-more-label", "read-more-link"]))
}
}

})